import { DeleteOutlined } from '@icon';
import { Table } from '@ui';
import moment from 'moment';
import React from 'react';
import type { Column } from 'react-table';

interface UseColumnsProps {
  onDeleteClick: (record: any) => void;
}

export function useColumns(params: UseColumnsProps) {
  const { onDeleteClick } = params;

  return React.useMemo<Column<any>[]>(
    () => [
      { id: 'name', Header: 'Názov', accessor: 'name' },
      {
        id: 'date',
        Header: 'Prax od',
        accessor: 'from',
        Cell: ({ row }: any) => <>{moment(row.original.from).format('LL')}</>,
      },
      {
        id: 'years',
        Header: 'Počet rokov praxe',
        accessor: 'from',
        Cell: ({ row }: any) => <>{moment().diff(row.original.from, 'year')}</>,
      },
      {
        id: 'actions',
        Header: '',
        Cell: ({ row }: any) => (
          <Table.Actions
            items={[
              {
                key: 'del',
                variant: 'danger',
                Icon: DeleteOutlined,
                label: 'Odstrániť',
                onClick: () => onDeleteClick(row.original),
              },
            ]}
          />
        ),
      },
    ],
    [onDeleteClick],
  );
}
